import { useMemo } from "react";
import { useIdioma } from "../../i18n/IdiomaProvider";
import styles from "./MedidorForcaSenha.module.css";

export interface CriterioSenha {
  chave: string;
  rotulo: string;
  atendido: boolean;
}

/** Critérios da política de senha do sistema — mesmas regras validadas no backend (rpc.controller.js `erroForcaSenha`). */
export function avaliarForcaSenha(senha: string): CriterioSenha[] {
  return [
    { chave: "tamanho", rotulo: "8+ Caracteres", atendido: senha.length >= 8 },
    { chave: "maiuscula", rotulo: "Letra Maiúscula", atendido: /[A-Z]/.test(senha) },
    { chave: "numero", rotulo: "Número", atendido: /[0-9]/.test(senha) },
    { chave: "especial", rotulo: "Especial (!@#)", atendido: /[^a-zA-Z0-9]/.test(senha) },
  ];
}

export function senhaAtendeRequisitos(senha: string): boolean {
  return avaliarForcaSenha(senha).every((criterio) => criterio.atendido);
}

/** Checklist visual dos requisitos de senha, com barra de progresso que valida ao digitar. */
export function MedidorForcaSenha({ senha }: { senha: string }) {
  const { traduzir } = useIdioma();
  const criterios = useMemo(() => avaliarForcaSenha(senha), [senha]);
  const atendidos = criterios.filter((criterio) => criterio.atendido).length;
  const percentual = (atendidos / criterios.length) * 100;
  const corBarra = atendidos >= criterios.length
    ? styles.barraForte
    : atendidos >= 2
      ? styles.barraMedia
      : styles.barraFraca;

  return (
    <div className={styles.container}>
      <ul className={styles.lista}>
        {criterios.map((criterio, indice) => (
          <li key={criterio.chave} className={styles.item}>
            <span className={`${styles.ponto} ${criterio.atendido ? styles.pontoAtivo : ""}`} aria-hidden="true" />
            <span className={criterio.atendido ? styles.rotuloAtivo : styles.rotulo}>
              {traduzir(criterio.rotulo)}
            </span>
            {indice < criterios.length - 1 && (
              <span className={styles.separador} aria-hidden="true">›</span>
            )}
          </li>
        ))}
      </ul>
      <div className={styles.trilha} role="progressbar" aria-valuenow={atendidos} aria-valuemin={0} aria-valuemax={criterios.length}>
        <div className={`${styles.preenchimento} ${corBarra}`} style={{ width: `${percentual}%` }} />
      </div>
    </div>
  );
}
